import { useEffect, useState } from "react";
import styles from "./BookingHistory.module.css";
import { getLocationName } from "../Common/Common";
import { useSelector } from "react-redux";
import BookingCancelModal from "./BookingCancelModal";
import MyAxios from "../axios/CustomAxios";

const BookingHistory = ({ searchResult, isSearchList, searchStatus }) => {
  const { locations } = useSelector((state) => state.gdInfoSlice);
  const [cancelSlotInfo, setCancelSlotInfo] = useState(null);
  const [cancelBookingInfo, setCancelBookingInfo] = useState(null);

  const [bookingData, setBookingData] = useState(null);

  useEffect(() => {
    if (!isSearchList) {
      getRecentBooking();
    } else {
      setBookingData(searchResult);
    }
  }, [isSearchList]);

  const getRecentBooking = () => {
    try {
      MyAxios.get(`/booking/get-booking-history`)
        .then((res) => {
          if (res.data) {
            setBookingData(res.data);
          } else {
            setBookingData(null);
          }
        })
        .catch((err) => {
          console.error(err);
          setBookingData(null);
        });
    
    } catch (err) {
      console.error(err);
      localStorage.removeItem("token");
      window?.location?.reload && window.location.reload();
    }
  };

  const getSlotCancelBtn = (bData, sData, forBooking, currentSTiming) => {
    if (
      bData.isBookingCancelled ||
      (!forBooking && bData.slotDetail.length < 2) ||
      sData.isSlotCancelled
    )
      return forBooking ? null : <></>;

    const date = bData.date;
    const time = forBooking ? sData.slotCombinedTiming[0] : currentSTiming.timing ;
    const [startTime] = time.split(" - ");

    // Fix the time format: "11.30AM" → "11:30 AM"
    const fixedTime = startTime
      .replace(".", ":") // Replace dot with colon
      .replace(/(AM|PM)/, " $1"); // Add space before AM/PM

    const dateTimeString = `${date} ${fixedTime}`;
    const targetTime = new Date(dateTimeString);
    const now = new Date();

    if (
      !isNaN(targetTime.getTime()) &&
      targetTime >= now &&
      targetTime - now >= 0.5 * 60 * 60 * 1000 // hour * min * sec*1000
    ) {
      return forBooking ? (
        true
      ) : (
        <button
          className={styles.actionBtn}
          onClick={onSlotCancel.bind(this, sData, bData, currentSTiming)}
        >
          Cancel Slot
        </button>
      );
    } else {
      return forBooking ? null : <></>;
    }
  };

  const onSlotCancel = (sData, bData, currentSTiming) => {
    setCancelSlotInfo({
      slotData: {...sData},
      cancelSlotTiming: currentSTiming,
      bookingFullInfo: bData
    });
  };

  const onBookingCancel = (bData) => {
    setCancelBookingInfo(bData);
  };

  const closeModal = () => {
    setCancelSlotInfo(null);
    setCancelBookingInfo(null);
  };

  const toMinutes = (timeStr) => {
    const [time, modifier] = timeStr.match(/(\d{2}\.\d{2})(AM|PM)/i).slice(1);
    let [hours, minutes] = time.split(".").map(Number);

    if (modifier.toUpperCase() === "PM" && hours !== 12) hours += 12;
    if (modifier.toUpperCase() === "AM" && hours === 12) hours = 0;

    return hours * 60 + minutes;
  };

  const getBookingCancelBtn = (bData) => {
    if (bData.isBookingCancelled) return <></>;

    const slotDetail = bData.slotDetail.filter(
      (sData) => !sData.isSlotCancelled
    );

    if (slotDetail.length > 0) {
      let isCancelAvailable = false;

      const filteredList = slotDetail.filter(
        (sData) => sData.slotCombinedTiming?.length > 0
      );
      if (filteredList.length > 0) {
        const earliestSlot = filteredList.reduce((earliest, current) => {
          const currentStartTime = toMinutes(
            current.slotCombinedTiming[0].split(" - ")[0]
          );
          const earliestTime = toMinutes(
            earliest.slotCombinedTiming[0].split(" - ")[0]
          );
          return currentStartTime < earliestTime ? current : earliest;
        });

        isCancelAvailable = getSlotCancelBtn(bData, earliestSlot, true);
      }

      if (isCancelAvailable) {
        return (
          <div>
            <button
              className={styles.actionBtn}
              onClick={onBookingCancel.bind(this, bData)}
            >
              Cancel Booking
            </button>
          </div>
        );
      } else {
        return <></>;
      }
    } else {
      return <></>;
    }
  };

  const updateBookingData = (cancelInfo) => {
    const bData = bookingData ? [...bookingData] : [];
    let bookingPos = bData.findIndex(
      (bData) => bData.bookingId == cancelInfo.bookingId
    );
    if (bookingPos > -1) {
      if (cancelInfo.isBookingCancelled) {
        bData[bookingPos].isBookingCancelled = true;
      } else {
        bData[bookingPos] = cancelInfo;
      }
    }
    setBookingData(bData);
    closeModal();
  };

  const getSlotTableDesign = (bData, sData, i, sTime, ii, isCancelled) => {
    return (
      <tr key={`tr-slot-${i}-${ii}`}>
        <td>
          <div>{sTime.timing}</div>
        </td>
        <td className={styles.categoryLabel}>{sData.category}</td>
        <td className={styles.slotLabel}>
          {`${sData.consoleType} - ${
            sData.slot_id ? sData.slot_id.slice(sData.slot_id.length - 1) : ""
          }`}
        </td>
        <td>{sData.slotPlayers}</td>
        <td>{sTime.price}</td>
        {isCancelled && <td>Cancelled</td> || <td>{getSlotCancelBtn(bData, sData, false, sTime)}</td>}
      </tr>
    )
  }

  const bindEachSlotDetail = (bData, sData, i) => {
    const slotHtml = sData?.slotTimingAndPricing?.map((sTime, ii) =>
      getSlotTableDesign(bData, sData, i, sTime, ii)
    ) || [];

    const cancelledSlotHTML =
      sData?.canceledSlotTimingAndPricing?.map((sTime, ii) =>
        getSlotTableDesign(bData, sData, i, sTime, ii, true)
      ) || [];

    return slotHtml.concat(cancelledSlotHTML);
  };

  return (
    <div className={styles.bookingContent}>
      {(bookingData?.length > 0 && (
        <>
          {!isSearchList && (
            <div className={`${styles.container} ${styles.containerHeader}`}>
              <h2 className={`m0`}>Last 5 Bookings</h2>
            </div>
          )}
          {bookingData.map((bData, index) => {
            return (
              <div
                key={`bconatiner-${index}`}
                className={`${styles.container}`}
              >
                {bData.isBookingCancelled && <div className={styles.cancelledOverlay}></div>}
                <div className={styles.bDataHeader}>
                  <div className={`mt0`}>
                    <span className={styles.headLabel}>Booking ID: </span>
                    {bData.bookingId}
                  </div>
                  <div>
                    <span className={styles.headLabel}>Location: </span>
                    {getLocationName(locations, bData.loc_id)}
                  </div>
                  <div>
                    <span className={styles.headLabel}>Date: </span>
                    {bData.date}
                  </div>
                  <div>
                    <span className={styles.headLabel}>Total Price: </span>
                    {bData.totalBookingAmount}

                    {bData.isBookingCancelled && (
                      <span className={`${styles.cancledLabel}`}>
                        {" "}
                        Booking Cancelled
                      </span>
                    )}
                  </div>
                  {getBookingCancelBtn(bData)}
                </div>

                <div className={styles.tableWrapper}>
                  <table className={styles.table}>
                    <thead>
                      <tr>
                        <th>Timing</th>
                        <th>Category</th>
                        <th>Slot</th>
                        <th>Players</th>
                        <th>Price</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {bData?.slotDetail?.map((sData, i) =>
                        bindEachSlotDetail(bData, sData, i)
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            );
          })}
        </>
      )) || (
        <div className={`${styles.container} ${styles.noResultContainer}`}>
          <h2 className={`m0`}>
            {isSearchList ? searchStatus : "No recent bookings"}
          </h2>
        </div>
      )}
      {(!!cancelSlotInfo || !!cancelBookingInfo) && (
        <BookingCancelModal
          cancelSlotInfo={cancelSlotInfo}
          cancelBookingInfo={cancelBookingInfo}
          closeModal={closeModal}
          updateBookingData={updateBookingData}
        />
      )}
    </div>
  );
};

export default BookingHistory;
